<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>상품안내</li>
        <li>포괄보험 안내</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>포괄보험 안내</h2>
        <div class="depLink">
          <button type="button" title="메뉴"><span>포괄보험 안내</span></button>
          <ul>
            <li>
              <router-link to="/insursumCargoidm"
                ><span>적하보험의 개요</span></router-link
              >
            </li>
            <li>
              <router-link to="/cargotarProdguid"
                ><span>적하보험의 가입대상</span></router-link
              >
            </li>
            <li>
              <router-link to="/condcovProdguid"
                ><span>조건별 담보안내</span></router-link
              >
            </li>
            <li>
              <router-link to="/insurstrtProdguid"
                ><span>보험의 개시와 종료</span></router-link
              >
            </li>
            <li>
              <router-link to="/premcalProdguid"
                ><span>보험료 산출 및 납입</span></router-link
              >
            </li>
            <li>
              <router-link to="/blaninsurProdguid"
                ><span>포괄보험 안내</span></router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="conStyle2">
          <div class="imgWrap">
            <img src="@/assets/images/imgPdtInfo3.png" alt="" />
          </div>

          <div class="txtWrap">
            <p class="tit">
              포괄 적하보험은,<br />
              <span class="fcRed">무보험</span> 상태에서 겪는<br />
              불이익을 <span class="fcRed">피할 수 있습니다.</span>
            </p>
            <p class="txt">
              포괄 적하보험이란 보험계약의 내용, 즉 보험의 목적물, 보험가입
              금액,<br />
              운송용구 등이 확정되지 않은 상태에서 그 범위를 포괄적으로
              정하고,<br />
              추후 내용이 구체적으로 확정되어, 개별운송 위험이 개시된 때에<br />
              보험자가 그 위험을 담보하고 보험료를 월별 정산하는 방식에 의해<br />
              이루어지는 보험계약 형태를 말합니다.<br />
              따라서 포괄 적하보험은 정기적으로 화물을 수출하여야 하는
              수출자나<br />
              장래에 계속적으로 수입할 화물을 확보한 수입자가 무보험 상태로부터
              겪을 수 있는<br />
              불이익을 피할 수 있는 장점이 있습니다.
            </p>
          </div>
        </div>
      </div>

      <div class="conStyle5">
        <div class="conWrap">
          <p class="tit">적용대상 업체</p>
          <p class="txt">
            계약체결 당회계년도의 전년도 1월 1일부터 12월 31일까지의
            <span class="fcRed"
              >1년간 적하보험 수입영업보험료가 2,000만원 이상인 보험계약자</span
            ><br />
            로 보험개발원에서 포괄 적하보험 계약 대상으로 발표하거나 인정한
            업체로 한정합니다.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
</script>

<style></style>
